<template>
  <el-dialog
    v-el-drag-dialog
    no="dialog"
    :visible.sync="innerVisible"
    :title="title"
    width="300px"
    :close-on-click-modal="false"
  >
    <el-form label-width="0">
      <el-form-item>
        <el-input
          v-show="operatorId==='btSiteRemark'"
          v-model="aeJob.siteRemark"
          no="siteRemark"
          type="textarea"
          :rows="5"
        />
        <el-input
          v-show="operatorId==='btOperatorRemarks'"
          v-model="aeJob.remarks"
          no="remarks"
          type="textarea"
          :rows="5"
        />
        <el-input
          v-show="operatorId==='btOtherWarehouseNotes'"
          v-model="aeJob.otherWarehouseNotes"
          no="otherWarehouseNotes"
          type="textarea"
          :rows="5"
        />
        <el-input
          v-show="operatorId==='btOtherCharges'"
          v-model="aeJob.otherCharges"
          no="otherCharges"
          type="textarea"
          :rows="5"
        />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button no="Confirm" type="primary" @click="clickHandler">{{ $t('CargoMsg.Cargo_Confirm') }}</el-button>
      <el-button no="Cancel" @click="innerVisible=false">{{ $t('Message.Cancel') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { getLoading4Cxt } from '@/utils/utilBaseElement'
import { AirExportJob } from '@/class/model/booking/AirExportJob'
import { saveAeBookingSpace } from '@/api/AirExport/airExportJob'

export default {
  name: 'OperatorRemarkDialog',
  props: {
    visible: { type: Boolean, required: true },
    operatorId: { type: String, required: true },
    job: { type: Object, required: true }
  },
  data() {
    return {
      innerVisible: this.visible,
      loading: null,
      title: '',
      aeJob: {
        siteRemark: '',
        remarks: '',
        otherWarehouseNotes: '',
        otherCharges: ''
      }
    }
  },
  watch: {
    visible(newVal) {
      if (newVal) {
        switch (this.operatorId) {
          case 'btSiteRemark':
            this.title = this.$t('queryJob.siteRemarks')
            break
          case 'btOperatorRemarks':
            this.title = this.$t('SeaExport.AdditionalNotes')
            break
          case 'btOtherWarehouseNotes':
            this.title = this.$t('queryJob.otherInstructions')
            break
          case 'btOtherCharges':
            this.title = this.$t('Pricing.OtherCharge')
            break
        }
        if (this.job.uuid) {
          const newJob = { uuid: this.job.uuid }
          this.loading = getLoading4Cxt(this)
          new AirExportJob(newJob).loadJobRelated({ job: true }).then(() => {
            this.aeJob = newJob
          }).finally(() => {
            this.loading.close()
          })
        }
      }
      this.innerVisible = newVal
    },
    innerVisible(newVal) {
      this.$emit('update:visible', newVal)
    }
  },
  methods: {
    clickHandler() {
      saveAeBookingSpace({ job: this.aeJob }).then(res => {
        const job = res.data.job
        this.job.siteRemark = job.siteRemark
        this.job.remarks = job.remarks
        this.job.otherWarehouseNotes = job.otherWarehouseNotes
        this.job.otherCharges = job.otherCharges
        this.job.version = job.version
        this.$message.success(this.$t('Message.SaveSucceed'))
        this.$emit('callback')
        this.innerVisible = false
      })
    }
  }
}
</script>
